import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import { getTaskDetail, postTask, updateTask } from '@blade-sxp/task-management/api/creat-task/index';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty, cloneDeep } from 'lodash';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import httpConfidence from '@blade-sxp/task-management/components/http-confidence.vue';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
import LibraryOptional from '@blade-sxp/task-management/components/library-type/index.vue';
import VehicleMode from '@blade-sxp/task-management/components/vehicle-mode.vue';
import AlarmLevel from '@blade-sxp/task-management/components/alarm-level.vue';
import AlarmMode from '@blade-sxp/task-management/components/alarm-mode.vue';
let FaceVehicleTask = class FaceVehicleTask extends Vue {
    loading = true;
    isDetail = false;
    isReady = false;
    isError = false;
    disableRight = true;
    id = '';
    type = 'add';
    taskType = 'FACE_ATTRIBUTE';
    name = '';
    status = 'ENABLE';
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    remark = '';
    libraryId = [];
    libraryOption = {
        name: `${this.$t('libraryName')}`,
        type: 'vehicle',
    };
    controlMode = 'LICENSE_PLATE_ATTRIBUTE';
    level = 'CRITICAL';
    mode = 'MATCHED';
    httpUrl;
    get libraryIdIsVal() {
        return this.libraryId && this.libraryId.length > 0;
    }
    get isModef() {
        return this.isDetail || (this.type !== 'add' && this.type !== 'copy') || !this.libraryIdIsVal;
    }
    get formData() {
        const { name, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, libraryId } = this;
        return {
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
            libraryId,
        };
    }
    init() {
        this.clearData();
        const { type, id, taskType } = this.$route.query;
        if (!type) {
            this.$message.error(`${this.$t('common.unknownError')}`);
        }
        this.type = type;
        this.id = id;
        this.taskType = taskType;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            this.isReady = true;
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    async validForm() {
        if (this.isDetail) {
            return;
        }
        // if (!this.isReady) {
        //   this.disableRight = true;
        //   return;
        // }
        if (!this.libraryIdIsVal) {
            this.controlMode = 'LICENSE_PLATE_ATTRIBUTE';
            this.level = 'CRITICAL';
        }
        for (let i = 1; i <= 4; i++) {
            if (this.$refs['formItem' + i]) {
                let res = await this.$refs['formItem' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        this.disableRight = false;
    }
    clearData() {
        this.loading = true;
        this.isDetail = false;
        this.isReady = false;
        this.isError = false;
        this.disableRight = true;
        this.id = '';
        this.type = 'add';
        this.taskType = 'FACE_ATTRIBUTE';
        this.name = '';
        this.status = 'ENABLE';
        this.effectivePeriod = 'PERMANENT';
        this.effectiveDates = {
            start: '',
            end: '',
        };
        this.effectiveTimes = [{ start: '', end: '' }];
        this.dayOfWeeks = [];
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                customClass: 'task-confirm',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const req = {
            taskName: this.name,
            remark: this.remark,
            taskStatus: taskStatus,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    enabledAlarmLevels: [this.level],
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : [...effectiveTimes],
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        structDetectThreshold: {
                            libraryIds: this.libraryId || [],
                            structAlertType: this.mode,
                        },
                    },
                ],
            },
            deviceTaskConfigs: this.formatPortraitToData(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            postTask(req).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            updateTask({ taskId: this.id, ...req }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    getData() {
        getTaskDetail(Number(this.id)).then(({ name, status, remark, alarmConfig: { thresholdConfigs, notifyConfig }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (notifyConfig) {
                [this.level] = notifyConfig?.enabledAlarmLevels;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes, structDetectThreshold } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
                if (structDetectThreshold) {
                    const { libraryIds = [], structAlertType = '' } = structDetectThreshold || {};
                    this.libraryId = libraryIds;
                    this.mode = structAlertType;
                }
            }
            if (deviceTaskConfigs && !isEmpty(deviceTaskConfigs)) {
                deviceTaskConfigs.forEach((item) => {
                    const roiData = item.roiData;
                    if (!isEmpty(roiData)) {
                        const analysis = JSON.parse(roiData);
                        DeviceIdDataModule.deviceIdRequestParams.set(analysis.id, analysis);
                    }
                });
                this.controlMode = deviceTaskConfigs[0]?.automobileAttributeAlertConfig?.attributeAlertTypeEnum;
            }
            this.loading = false;
        });
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    formatPortraitToData() {
        let config = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let requestMap = new Map();
        requestMap = cloneDeep(device);
        const incidentType = plotMap.get(this.taskType).incidentType;
        if (!isEmpty(requestMap) && !isEmpty(incidentType)) {
            requestMap.forEach((item) => {
                let rawRoi = [];
                let twinRoi = [];
                const { zoneId, deviceId, titleList } = item;
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'ROI') {
                            item.data.forEach((item) => {
                                const { vertices, id } = item;
                                vertices.shift();
                                rawRoi.push({
                                    rawRoi: {
                                        vertices,
                                        id: this.taskId(),
                                        name: id,
                                    },
                                });
                            });
                        }
                    });
                }
                let data = {
                    automobileAttributeAlertConfig: {
                        attributeAlertTypeEnum: this.controlMode,
                        roiMappings: [...rawRoi, ...twinRoi],
                    },
                    zoneId,
                    deviceId,
                    incidentType,
                    roiData: JSON.stringify(device.get(deviceId)),
                };
                config.push(data);
            });
        }
        return config;
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], FaceVehicleTask.prototype, "init", null);
__decorate([
    Watch('formData', { deep: true })
], FaceVehicleTask.prototype, "validForm", null);
FaceVehicleTask = __decorate([
    Component({
        name: 'FaceVehicleTask',
        components: {
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            'button-box': ButtonBox,
            'device-darwer': DeviceDarwer,
            'http-confidence': httpConfidence,
            'task-note': TaskNote,
            'library-optional': LibraryOptional,
            'vehicle-mode': VehicleMode,
            'alarm-level': AlarmLevel,
            'alarm-mode': AlarmMode,
        },
        i18n: {
            messages: {
                en: {
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    tip: 'Title',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    libraryName: 'Vehicle Library',
                    placeholder: 'Please select vehicle library',
                    control: 'Control (optional)',
                    alert: 'Alert Notification',
                },
                zh: {
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    libraryName: '选择车辆库',
                    placeholder: '请选择车辆库',
                    control: '布控 (可选)',
                    alert: '告警通知',
                },
            },
        },
    })
], FaceVehicleTask);
export default FaceVehicleTask;
